import React from 'react';
import styled from 'styled-components';
import SubscribeFrom from 'react-mailchimp-subscribe';
//
import AngleRight from 'components/svg/fontawesome/AngleRight';
//
export default ({ listId, inputPlaceholder }) => {
  const action = `https://matthewfone.us2.list-manage.com/subscribe/post?u=11c77a02b8671d3f6314b1866&amp;id=${listId}`;

  const formProps = {
    action,
    messages: {
      inputPlaceholder,
      btnLabel: <AngleRight />,
      sending: 'Subscribing…',
      success: 'Thank you.',
      // error: 'Already subscribed? If not, double check your email address.'
    },
    styles: {
      sending: {
        fontSize: '.9em',
        color: 'inherit',
      },
      success: {
        fontSize: '.9em',
        color: 'inherit',
      },
      error: {
        fontSize: '.9em',
        color: 'inherit',
      },
    },
  };

  return (
    <Subscribe>
      <SubscribeFrom {...formProps} />
    </Subscribe>
  );
};

const Subscribe = styled.div`
  margin: 1rem 0;
  max-width: 100%;
  position: relative;
  width: 100%;

  input {
    background-color: transparent;
    border: 2px solid currentColor;
    border-radius: 0;
    box-shadow: none;
    margin: 0;
    outline: 0;
    padding: 0.5rem 0.5rem;
    text-align: left;
    width: 100%;
    -webkit-appearance: none;
  }

  button {
    align-items: center;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    bottom: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    margin: auto 0;
    min-width: 20px;
    outline: 0;
    padding: 0 0.5rem;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
    -webkit-appearance: none;

    svg {
      width: 10px;
    }
  }

  p {
    left: 0;
    margin: 1em auto;
    padding: 0.25rem;
    position: absolute;
    right: 0;
    top: 100%;
  }
`;
